<template>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7">
            <path d="M7.49993 13.4996L4.58327 10.5829C4.25827 10.2579 3.7416 10.2579 3.4166 10.5829C3.0916 10.9079 3.0916 11.4246 3.4166 11.7496L6.90827 15.2413C7.23327 15.5663 7.75827 15.5663 8.08327 15.2413L16.9166 6.41628C17.2416 6.09128 17.2416 5.57461 16.9166 5.24961C16.5916 4.92461 16.0749 4.92461 15.7499 5.24961L7.49993 13.4996Z" fill="#777777"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "DoneIcon"
}
</script>

<style scoped>

</style>